import { Props_SnippetImageContent } from './ImageContent.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, link } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content-column__heading--${heading.visibility.value}` : ''
    const classSnippetLayout = `snippet-image-content--${snippet.layout?.value}`
    const classBackgroundColor = snippet.backgroundColor?.value ? `snippet-image-content--${snippet.backgroundColor.value}` : ''

    return (
        <section className={`snippet-image-content ${classSnippetLayout} ${classBackgroundColor}`} id={snippet.snippetid?.value || ''}>
            <div className="snippet-image-content__container">
                <div className="snippet-image-content__container-image">
                    <img
                        loading="lazy"
                        src={image.src?.value}
                        className="snippet-image-content__image"
                        height="360"
                        width="600"
                        alt={image.alt?.value ? image.alt.value : ''}
                    />
                </div>
                <div className="snippet-image-content__container-content">
                    <div className="snippet-image-content__inner-content-container">
                        <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                        {content.content?.value && <div className="snippet-image-content__content">
                            {CompileMarkdown(content.content.value || '')}
                        </div>}
                        {link.url?.value && link.content?.value && (
                            <a
                                className="snippet-image-content__link"
                                href={link.url.value}
                                target={link.openInNewTab?.value === 'true' ? '_blank' : '_self'}
                                rel={link.openInNewTab?.value === 'true' ? 'noopener noreferrer' : undefined}
                            >
                                {link.content?.value}
                            </a>
                        )}</div>
                </div>
            </div>
        </section>
    )
}

export default SnippetImageContent